export default {
  title: 'Factures',
  form: {
    auto_generate_invoices: {
      label: 'Générer les factures automatiquement',
    },
  },
  buttons: {
    save: 'Enregistrer',
  },
  toasts: {
    failed_to_save_changes: "Échec de l'enregistrement des modifications",
    changes_got_saved: 'Modifications enregistrées',
  },
};
